import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { UserModel } from "../interfaces/user-model";
import { USER_INFO } from "../variables/api";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../environments/environment";
import { UserFacade } from "../store/facade/user.facade";
import { UserActions } from "../store/actions";

@Injectable({
    providedIn: "root",
})
export class AuthService {
    private userFacade = inject(UserFacade);
    private http = inject(HttpClient);
    private readonly cookieService = inject(CookieService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    isLoggedIn(): boolean {
        return this.cookieService.check(environment.cookieName);
    }

    handleLogin(): void {
        if (this.isLoggedIn()) {
            this.route.queryParams.subscribe((param) => {
                const redirectUrl = param["redirect"];

                if (redirectUrl) {
                    this.router.navigateByUrl(redirectUrl);
                }
            });
            this.userFacade.loadUser();
            this.userFacade.store.dispatch(
                UserActions.startSessionMonitoring(),
            );
        }
    }

    getUserInfo(): Observable<UserModel | null> {
        return this.http.get<UserModel>(USER_INFO);
    }

    redirectToLogin(): void {
        const currentUrl = encodeURIComponent(window.location.href);
        window.location.href = `${environment.loginGwoUrl}?redirect=${currentUrl}`;
    }

    logout(): void {
        this.cookieService.delete(
            `${environment.cookieName}`,
            "/",
            `${environment.domainName}`,
        );
    }
}
